import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { PLAN_AVAILABILITY_NOTICE } from "@/lib/planCheckoutAccess";

export const PlanAvailabilityDialog = ({ open, onOpenChange }) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent data-testid="plan-availability-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle data-testid="plan-availability-dialog-title">
            {PLAN_AVAILABILITY_NOTICE.title}
          </AlertDialogTitle>
          <AlertDialogDescription data-testid="plan-availability-dialog-body">
            {PLAN_AVAILABILITY_NOTICE.body}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogAction data-testid="plan-availability-dialog-close-button">
            Got it
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};